import { ClassName } from '@boxcryptor-web/shared/class-name';
import classnames from 'classnames';
import { focusRingClassNames } from '../general';
import { ExternalLinkProps } from './ExternalLink';

const getLinkClasses = () => 'font-medium text-brand-600 hover:text-brand-300 transition ease-in-out duration-150 px-0.5 mx-0.5';

export const StyledExternalLink: React.FC<ExternalLinkProps> = ({
  href,
  target = '_blank',
  rel = 'noopener noreferrer',
  className,
  children,
}) => {
  return (
    <a className={classnames(getLinkClasses(), focusRingClassNames, className)} href={href} target={target} rel={rel}>
      {children}
    </a>
  );
};

export const ButtonLink: React.FC<ClassName & { onClick?: (event: React.MouseEvent) => void; children?: React.ReactNode }> = ({
  onClick,
  className,
  children,
}) => (
  <button type="button" className={classnames(getLinkClasses(), className)} onClick={onClick}>
    {children}
  </button>
);
